import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useState, useCallback } from 'react';
import { useMergeRefs } from 'use-callback-ref';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var useClickable = function useClickable(_ref) {
  var _ref$ref = _ref.ref,
      htmlRef = _ref$ref === void 0 ? null : _ref$ref,
      onClick = _ref.onClick,
      shouldClickOnEnter = _ref.shouldClickOnEnter,
      tabIndex = _ref.tabIndex,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isFocusable = _ref.isFocusable,
      isFocusable = _ref$isFocusable === void 0 ? true : _ref$isFocusable;

  var _useState = useState(true),
      isButton = _useState[0],
      setIsButton = _useState[1];

  var refCallback = useCallback(function (node) {
    if ((node == null ? void 0 : node.tagName) !== "BUTTON") {
      setIsButton(false);
    }
  }, []);

  var _tabIndex = isButton ? tabIndex : tabIndex || 0;

  var trulyDisabled = isDisabled && !isFocusable;
  var handleClick = React.useCallback(function (event) {
    if (isDisabled) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }

    var self = event.currentTarget;
    isFocusable && self.focus();
    onClick == null ? void 0 : onClick(event);
  }, [isFocusable, isDisabled, onClick]);
  var handleKeyDown = React.useCallback(function (event) {
    if (isDisabled || event.defaultPrevented || event.metaKey) {
      return;
    }

    var shouldClick = shouldClickOnEnter && event.key === "Enter";

    if (!isButton && shouldClick) {
      event.preventDefault();
      var self = event.currentTarget;
      self.click();
    }
  }, [isDisabled, isButton, shouldClickOnEnter]);
  var ref = useMergeRefs([htmlRef, refCallback]);
  var buttonAttrs = {
    type: "button",
    disabled: trulyDisabled
  };
  var nonButtonAttrs = {
    role: "button",
    tabIndex: trulyDisabled ? void 0 : _tabIndex
  };

  if (!onClick) {
    return {
      "aria-disabled": isDisabled
    };
  }

  return __spreadValues({
    ref: ref,
    "aria-disabled": isDisabled,
    onClick: handleClick,
    onKeyDown: handleKeyDown
  }, isButton ? buttonAttrs : nonButtonAttrs);
};

export { useClickable };